<template>
  <div>
    <rest-form-item :label="$t('ChannelConfig_Tola_Url')" prop="url">
      <el-input
        v-model="model.params.url"
        :placeholder="$t('ChannelConfig_Tola_Url_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item :label="$t('ChannelConfig_Tola_Channel')" prop="channel">
      <el-input
        v-model="model.params.channel"
        :placeholder="$t('ChannelConfig_Tola_Channel_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item :label="$t('ChannelConfig_Tola_Username')" prop="username">
      <el-input
        v-model="model.params.username"
        :placeholder="$t('ChannelConfig_Tola_Username_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item :label="$t('ChannelConfig_Tola_Password')" prop="password">
      <el-input
        v-model="model.params.password"
        :placeholder="$t('ChannelConfig_Tola_Password_Placeholder')"
      />
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  components: { RestFormItem },
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    if (!this.$route.query.id) {
      this.$set(this.model, 'type', 'sms')
      this.$set(this.model, 'channel', 'tola')
      this.$set(this.model, 'params', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/providers/Tola.vue